import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../../../helpers/reselectHelpers';
import {getComposeCalendarVersion} from '../../../../../store/data/calendarVersions/calendarVersionsSelectors';
import {ComposerSchedulingDropdown} from './composerSchedulingDropdown';

/*
 * Selectors.
 */

const getHasNoCalendars = createSelector(
  [getComposeCalendarVersion],
  (calendarVersion) => calendarVersion === undefined,
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  hasNoCalendars: getHasNoCalendars,
}));

export const ComposerSchedulingDropdownContainer = connect(mapStateToProps)(ComposerSchedulingDropdown);
